module.exports = __webpack_public_path__ + "static/media/img-devops-aws-black.25c64d28.png";